// extracted by mini-css-extract-plugin
export var contatti = "contatti-module--contatti--eFwWh";
export var content1 = "contatti-module--content1--722Fw";
export var content2 = "contatti-module--content2--6n46K";
export var content3 = "contatti-module--content3--Nt1I6";
export var decagon = "contatti-module--decagon--CAR7C";
export var headline = "contatti-module--headline--90Vl4";
export var shape = "contatti-module--shape--OssDQ";